import useAuth from '@src/core/auth/components/auth0-wrapper';
import {
  ApplicationConfigurationKeyEnum,
  ApplicationConfigurationService,
} from '@src/core/application-configuration';
import { LocaleTranslationKeysEnum } from '@src/core/i18n/locale-translation-keys.enum';
import { RoutePathsEnum } from '@src/core/routing/route-paths.enum';
import { FC, useCallback } from 'react';
import { ErrorPageTemplate } from 'swo-ciam-common-react';
import image from '../../../../../../public/images/401.png';

const UnsupportedTenantErrorComponent: FC = () => {
  const { logout } = useAuth();
  const SSO_HELP_KNOWLEDGE_ARTICLE = ApplicationConfigurationService.getValue(
    ApplicationConfigurationKeyEnum.ssoHelpKnowledgeArticle
  );

  const buttonClickHandler = useCallback(
    () => logout({ returnTo: window.location.origin }),
    [logout]
  );

  return (
    <ErrorPageTemplate
      items={[
        { key: LocaleTranslationKeysEnum.AuthUnsupportedTenantErrorTitle },
        {
          key: LocaleTranslationKeysEnum.AuthUnsupportedTenantErrorSubTitle,
        },
        {
          key: LocaleTranslationKeysEnum.AuthUnsupportedTenantErrorHelpText,
        },
        {
          key: LocaleTranslationKeysEnum.AuthUnsupportedTenantErrorDescription,
          values: {
            url: SSO_HELP_KNOWLEDGE_ARTICLE,
          },
        },
      ]}
      link={{ external: false, url: RoutePathsEnum.Home }}
      image={{ src: image, alt: LocaleTranslationKeysEnum.SwoErrorPages404ImgAlt }}
      button={{
        label: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoLoginScreen,
        placeholder: LocaleTranslationKeysEnum.SwoErrorPagesSharedActionsGoLoginScreen,
        onClick: buttonClickHandler,
      }}
      footerText={{
        key: LocaleTranslationKeysEnum.SwoErrorPagesSharedFooterText,
      }}
    />
  );
};

export default UnsupportedTenantErrorComponent;
